/**
 * The absolute path an app is mounted at: the app's segment under the customer a session is scoped
 * to (`/c/banner/arc`).
 *
 * One owner for the string, so an app switch and the header's nav cannot disagree about the shape of
 * a customer-scoped app path, and `/c/` stays a prefix only the shell knows. An app is told its mount
 * path rather than building one, because every link an app renders is relative (Atlas ADR-0021).
 */
export const appMountPath = (customer: string, appId: string): string =>
  `/c/${customer}/${appId}`
